import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'
import { HomePage } from '../../pages/home/home.component'
import { Feeds } from '../../layout/feeds/feed.component';
import { IdeaForm } from '../../components/ideaForm/ideaForm.component';
import { MyIdeas } from '../../layout/myIdeas/myIdeas.components';
import { LeaderBoard } from '../../layout/leaderBoard/leaderBoard.component';
import { JuryDetails } from '../../layout/juryDetails/juryDetails.component';
import { InnovativeForm } from '../../components/ideaForm/innovativeForm.component';
import { ChallengeForm } from '../../components/ideaForm/challengeForm.component';
import { LeaderBoardStats } from '../../layout/leaderBoard/leaderBoardStats.component';
import { useSelector } from 'react-redux';
import { PhuketForm } from '../../components/ideaForm/phuketForm';

// const {HomePage} = React.lazy(() => import('../../pages/home/home.component'));

export const HomeRoutes = () => {
    const empId = useSelector(state => state.user.empId)
    return (
        <Routes>
            <Route exact path="/" element={<HomePage />}>
                <Route exact path='/' element={<Feeds />} />
                <Route exact path='post-idea' element={<IdeaForm />} />
                <Route exact path='post-innovation' element={<InnovativeForm />} />
                <Route exact path='post-challenge' element={<ChallengeForm />} />
                <Route exact path='my-idea' element={<MyIdeas />} />
                <Route exact path='leader-board' element={<LeaderBoard/>} />
                <Route exact path='jury-details' element={<JuryDetails/>}/>
                {(empId == "amit.ray" || empId == "aamir.ali" || empId == "deepak.s" || empId == "christina.john")&& <Route exact path='leader-boardstats' element={<LeaderBoardStats/>} />}
                <Route exact path='idea-form' element={<PhuketForm/>}/>
            </Route>
            <Route path="*" element={<Navigate to={"/"} replace={true} />} />
        </Routes>
    )
}